let router = [
    {
        path: "/pc/policy/PolicyList",
        name: "PolicyList",
        component: () => import("../components/PolicyList.vue"),
        meta: {
            title: "政策专区",
            keepAlive: true,
        },
    },
    {
        path: "/pc/policy/PolicyNewsDetail",
        name: "PolicyNewsDetail",
        component: () => import("../components/PolicyNewsDetail.vue")
    },
    {
        path: "/pc/policy/portal/home/appealarea",
        name: "Appealarea",
        component: () => import("../components/AppealArea.vue")
    },
    {
        path: "/pc/policy/appealHanddle",
        name: "AppealHanddle",
        component: () => import("../components/AppealHanddle")
    },
    {
        path: "/pc/policy/recommenddetail",
        name: "recommenddetail",
        component: () => import("../components/homeMain/RecommendDetail.vue")
    },
    {
        path: "/pc/policy/recommendarea",
        name: "recommendarea",
        component: () => import("../components/homeMain/RecommendArea.vue")
    },
    // 服务专区栏目列表总入口
    {
        path: "/pc/policy/servicearea",
        name: "servicearea",
        component: () => import("../components/ServiceArea.vue")
    },
    {
        path: "/pc/policy/homeMainCopy",
        name: "homeMainCopy",
        component: () => import("../components/HomeMainCopy.vue")
    },
    {
        path: "/pc/policy/knowledge-search",
        name: "PolicyKnowledgeSearch",
        component: () => import("../components/PolicyKnowledgeSearch.vue"),
        props: route => ({
            initialKeyword: route.query.kw || "",
            appId: route.query.appId || route.query.app_id,
            topicId: route.query.topicId || route.query.id,
            topicName: route.query.topicName || "政策知识库"
        }),
        meta: {
            title: "政策知识检索",
            needLogin: true,
            waterMark: false
        }
    },
    {
        path: "/pc/policy/knowledge-detail",
        name: "PolicyKnowledgeDetail",
        component: () => import("../components/PolicyKnowledgeDetail.vue"),
        props: route => ({
            documentId: route.query.id || "",
            baseId: route.query.baseId || ""
        }),
        meta: {
            title: "政策知识详情",
            needLogin: true,
            waterMark: false
        }
    },
    // {
    //     path: "/pc/policy/policybreakdown",
    //     name: "policyBreakdown",
    //     component: () => import("../components/PolicyBreakdown.vue")
    // },
    // {
    //     path: "/pc/policy/supportstandard",
    //     name: "SupportStandard",
    //     component: () => import("../components/SupportStandard.vue")
    // }
];
export default router;
